module.exports = __webpack_public_path__ + "static/Klimate-55abc2d9262b69c17bb5421f204a51ab.jpg";